import React, { Fragment, useState, useEffect } from 'react';
import { Col, Row, Button } from 'reactstrap';
import AccountingAccountDataModal from './AccountingAccountDataModal';
import AccountingAccountDataTable from './AccountingAccountDataTable';

const AccountingAccountData = ({ getListAccountingAccount, accountingData }) => {

    const [openForm, setOpenForm] = useState(false);
    const [onUpdate, setOnUpdate] = useState(false);
    const [accountToUpdate, setAccountToUpdate] = useState(null);

    const DataTableAccountingAccount = () => {
        return (<AccountingAccountDataTable
            reactTableData={accountingData}
            setAccountToUpdate={setAccountToUpdate}
            setOnUpdate={setOnUpdate}
            setOpenForm={setOpenForm}
            getListAccountingAccount={getListAccountingAccount}
        />);
    }

    return (
        <Fragment>
            <Row>
                <Col md={10}>
                </Col>
                <Col md={2}>
                    <Button
                        color="primary"
                        variant="contained"
                        size="sm"
                        onClick={() => {
                            setOpenForm(!openForm);
                            if (!openForm) {
                                setOnUpdate(false)
                                setAccountToUpdate(null);
                            }
                        }}
                    >
                        {openForm ? "Cerrar Formulario" : "Crear Cuenta"}
                    </Button>
                </Col>
            </Row>
            {openForm &&
                <AccountingAccountDataModal onUpdate={onUpdate} getListAccountingAccount={() => getListAccountingAccount()} accountToUpdate={accountToUpdate} setOpenForm={setOpenForm} />
            }
            {accountingData.length > 0 ? <DataTableAccountingAccount /> : null}

        </Fragment>
    );
}

export default AccountingAccountData;
